import React from 'react';
import { useHistory } from 'react-router-dom';

import { Box } from '@material-ui/core';
import { STUDENTS_ASSIGNMENTS_LIST_URL } from 'config/urls';

import { colors } from 'theme/palette';

import Button from 'components/Button';
import Typography from 'components/Typography';

import styles from './styles.module.scss';

const AssignmentNotFound = () => {
  const history = useHistory();

  const handleRedirect = () => {
    history.push(STUDENTS_ASSIGNMENTS_LIST_URL);
  };

  return (
    <Box className={styles.errorContainer}>
      <Typography variant="H-TEXT-4" color={colors.blue}>
        Assignment does not exist.
      </Typography>
      <Button color="pink" onClick={handleRedirect}>
        Go back to Assignments List
      </Button>
    </Box>
  );
};

export default AssignmentNotFound;
